<form (ngSubmit)="$event.preventDefault(); saveSectionM();" [formGroup]="sectionMForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto">
    <div class="w-full overflow-y-auto px-1">
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            M. Team Determination
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4">
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Select one of the two following statements: *</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div>
                        <input type="radio" id="team_determination_yes" [value]="this.yesNo.Yes" class="hidden peer"
                            formControlName="team_determination">
                        <label for="team_determination_yes"
                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            The team is prepared to make a determination.
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="team_determination_no" [value]="this.yesNo.No" class="hidden peer"
                            formControlName="team_determination">
                        <label for="team_determination_no"
                            class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            The team needs additional information in order to make a determination.
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="sectionMForm.get('team_determination')?.value === this.yesNo.Yes"
                class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold mb-2">
                    <p>Select the statement that best reflects the team's determination:</p>
                </div>
                <div class="w-full flex flex-col items-start gap-2">
                    <div *ngFor="let question of questionsList" class="flex items-start gap-2 border-b border-gray-200 text-sm">
                        <input [id]="'team-determination-selection-' + question.value" type="radio" [value]="question.value" formControlName="team_determination_selection"
                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 mt-2">
                        <label [for]="'team-determination-selection-' + question.value">
                            <h2 class="text-start flex items-center justify-between w-full font-medium mb-2">
                                {{ question.questionText }}
                            </h2>
                            <div id="accordion-flush-body-1 text-sm">
                                <p class="mb-2">
                                    <span class="font-bold">Descriptors: </span>{{ question.descriptors}}
                                </p>
                                <p class="mb-2">
                                    <span class="font-bold">Immediate Response Requirement to Include: </span>{{ question.requirement }}
                                </p>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
            <div *ngIf="sectionMForm.get('team_determination')?.value === this.yesNo.No"
                class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold">
                    <p>Date to reconvene as a team to complete the team determination. *</p>
                </div>
                <div class="w-full flex items-center">
                    <div class="w-full relative">
                        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z" />
                            </svg>
                        </div>
                        <input id="datepicker-determination-date" #datepickerDeterminationDate
                            name="team_determination_plan_date" type="text"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block ps-10 p-2">
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.sectionMForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.sectionMForm.valid
                }" [disabled]="this.sectionMForm.invalid">
                Save
            </button>
        </div>
    </div>
</form>
  